module.exports = __webpack_public_path__ + "static/media/Abhay.a2f89af4.jpeg";